module.exports = __webpack_public_path__ + "img/eca-assurances.c7d1b058.png";